import Interface from './src/index.vue'

/* istanbul ignore next */
Interface.install = function (Vue) {
  Vue.component(Interface.name, Interface)
}

export default Interface
